/* FT Army Green batch notice
   Army Green is hand-dyed in small batches, so the tone can vary slightly between
   DIFFERENT styles (leggings vs. crop top vs. zip-up, etc.). When a cart holds 2+
   different Army Green styles, show ONE passive, non-blocking notice offering a
   hand-match service. Renders in the slide-out cart drawer and on the cart page.
   Idempotent + self-guarded: it only writes the DOM when the shown/hidden state
   actually needs to change, so it never fights the Mix cart script and its own
   MutationObserver cannot loop. Reversible: remove the asset + its loader line. */
(function () {
  'use strict';
  var STYLE_ID = 'ftag-style';
  var CSS =
    '.ftag-notice{margin:0 0 14px;border-radius:6px;padding:13px 15px;' +
    'font-family:"Open Sans",sans-serif;font-size:12.5px;line-height:1.5;' +
    'background:rgba(75,83,32,.07);border:1px solid rgba(75,83,32,.32);color:#3f4626;' +
    'display:flex;gap:11px;align-items:flex-start}' +
    '.ftag-notice__dot{flex:0 0 auto;width:16px;height:16px;border-radius:50%;margin-top:1px;' +
    'background:#4b5320;box-shadow:inset 0 0 0 1px rgba(0,0,0,.18)}' +
    '.ftag-notice__t{font-family:Montserrat,sans-serif;font-weight:700;font-size:12.5px;' +
    'display:block;margin-bottom:3px;color:#3f4626}' +
    '.ftag-notice a{font-weight:700;color:#4b5320;text-decoration:none;' +
    'border-bottom:1px solid currentColor;white-space:nowrap}';

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function isArmyGreen(it) {
    var ov = it.options_with_values || [];
    for (var i = 0; i < ov.length; i++) {
      if (/army\s*green/i.test(ov[i].value || '')) return true;
    }
    if (/army\s*green/i.test(it.variant_title || '')) return true;
    if (/-army-green(?:$|[-\/])/i.test(it.handle || '')) return true;
    if (/army\s*green/i.test(it.product_title || '')) return true;
    return false;
  }

  /* distinct Army Green STYLES = distinct product handles; two of the same style
     (same handle, different size) is one style and must NOT trigger the notice. */
  function distinctArmyGreenStyles(cart) {
    var seen = {}, n = 0;
    (cart.items || []).forEach(function (it) {
      if (!isArmyGreen(it)) return;
      var key = it.handle || it.product_id || it.product_title;
      if (key && !seen[key]) { seen[key] = 1; n++; }
    });
    return n;
  }

  var NOTICE_HTML =
    '<span class="ftag-notice__dot" aria-hidden="true"></span>' +
    '<span><span class="ftag-notice__t">Matching your Army Green set</span>' +
    'Army Green is dyed in small batches, so the tone can vary slightly between different ' +
    'styles. Want yours matched as closely as possible? ' +
    '<a href="https://instagram.com/fittribe.merch" target="_blank" rel="noopener">DM us @fittribe.merch</a> ' +
    'and we’ll pair the closest batches before we ship.</span>';

  function targets() {
    var t = [];
    var db = document.querySelector('.cart-drawer__body-content');
    if (db) t.push(db);
    if (location.pathname.indexOf('/cart') === 0) {
      var items = document.querySelector('form.ft-cart__items') || document.querySelector('.ft-cart__items');
      if (items) t.push(items);
    }
    return t;
  }

  function render(show) {
    targets().forEach(function (root) {
      var existing = root.querySelector(':scope > .ftag-notice');
      if (show && !existing) {
        ensureStyle();
        var box = document.createElement('div');
        box.className = 'ftag-notice';
        box.setAttribute('role', 'note');
        box.innerHTML = NOTICE_HTML;
        root.insertBefore(box, root.firstChild);
      } else if (!show && existing) {
        existing.remove();
      }
    });
  }

  var busy = false, lastShow = null;
  function refresh() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (x) { return x.json(); })
      .then(function (cart) {
        busy = false;
        var show = !!cart && distinctArmyGreenStyles(cart) >= 2;
        lastShow = show;
        render(show);
      })
      .catch(function () { busy = false; });
  }

  /* re-apply the cached decision when the drawer re-renders — no refetch, and only
     writes when the DOM state differs, so this can't loop the observer below. */
  function reapply() { if (lastShow !== null) render(lastShow); }

  var of = window.fetch;
  window.fetch = function () {
    var u = arguments[0] && (arguments[0].url || arguments[0]);
    var p = of.apply(this, arguments);
    if (typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u)) {
      p.then(function () { setTimeout(refresh, 400); setTimeout(refresh, 1300); });
    }
    return p;
  };
  var oo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u)) {
      this.addEventListener('load', function () { setTimeout(refresh, 400); setTimeout(refresh, 1300); });
    }
    return oo.apply(this, arguments);
  };
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[href*="/cart"],[class*="cart"]')) setTimeout(reapply, 500);
  }, true);

  var mo = new MutationObserver(function () {
    clearTimeout(window.__ftag);
    window.__ftag = setTimeout(reapply, 300);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
})();
